import { Link } from "react-router-dom";
import { Reveal } from "./Motion";
import { useLang } from "../i18n/LanguageContext";

export const CtaBand = () => {
  const { t } = useLang();
  return (
  <section className="bg-ink texture-grain">
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-periwinkle-light mb-6">{t.cta.kicker}</p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-cream font-medium leading-[1.05] max-w-3xl">
          {t.cta.title}
        </h2>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/contact"
            data-testid="cta-band-quote-btn"
            className="rounded-full bg-periwinkle text-ink px-8 py-4 font-semibold hover:bg-periwinkle-light transition-colors duration-300"
          >
            {t.cta.quote}
          </Link>
          <Link
            to="/services"
            data-testid="cta-band-services-btn"
            className="rounded-full border border-cream/30 text-cream px-8 py-4 font-semibold hover:border-cream hover:bg-cream/5 transition-colors duration-300"
          >
            {t.cta.services}
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
  );
};
